/* eslint-disable */
export default {
  _no: 'no',
}